/**
 * OpenAPI definition
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * Subaccount creation request
 */
export interface SubAccountCreationRequest {
  /**
   * Main account ID
   */
  parentAccountId: number;
  name: string;
  /**
   * STRATEGY: no client trading, FIX sessions and API keys.
   */
  subAccountType: SubAccountCreationRequest.SubAccountTypeEnum;
  allowNegativeEquityWithdraw: boolean;
  /**
   * True - means \'Internal\' account.
   */
  internalAccount: boolean;
}
export namespace SubAccountCreationRequest {
  export const SubAccountTypeEnum = {
    Trading: 'TRADING',
    Strategy: 'STRATEGY',
  } as const;
  export type SubAccountTypeEnum = (typeof SubAccountTypeEnum)[keyof typeof SubAccountTypeEnum];
}
